<template>
  <div id="app" :class="theme + ' ' + $route.name + (store.ui.state.nav.open ? ' nav-open' : '') + (store.user.state.user.guest ? ' guest' : '')">
    
    <TripplyHeader v-if="false" />
    <AppNav />

    <div id="tooltip"><span></span></div>

    <div id="page">
      <div id="content">
        <router-view :key="$route.fullPath" />
      </div>
      <AppFooter v-if="$route.matched[0]?.path !== '/r/:id'" />
    </div>

    <AppToasts />
    <AppModals />
    <div>
      <CookieConsent :show="cookieModal" />
      <RouteLimitExceeded :show="$route.path !== '/account' && routeLimitExceeded" />
    </div>

    <AppButton @click="store.modal.showModal('GiveFeedback')"
      v-if="store.auth.signedIn()"
      id="feedback"
      icon="feedback"
      color="primary"
      class="no-print button-icon-on-mobile">
        Giv feedback
    </AppButton>

  </div>
</template>

<script lang="ts">
import TripplyHeader from '@/components/TripplyHeader.vue'
import AppNav from '@/components/ui/nav/AppNav.vue'
import AppFooter from '@/components/ui/AppFooter.vue'
import AppToasts from '@/components/ui/AppToasts.vue'
import CookieConsent from '@/components/modals/CookieConsent.vue'
import RouteLimitExceeded from '@/components/modals/RouteLimitExceeded.vue'
import AppModals from '@/components/ui/AppModals.vue'

import { initializeStore, store } from '@/store'
import { defineComponent, ref, computed } from  'vue'

export default defineComponent({
  name: 'TripplyApp',
  components: { TripplyHeader, AppNav, AppFooter, AppToasts, AppModals, CookieConsent, RouteLimitExceeded },
  setup() {
    console.log('LOADED')
    
    initializeStore()
    const feedbackModal = ref(false)
    const theme = computed(() => store.global.state.theme)
    const routeStore = computed(() => store.route)
    const userStore = store.user.state
    const user = computed(() => store.auth.state.user)

    const routeLimitExceeded = computed(() => store.user.routeLimitExceeded())

    const cookieModal = computed(() => !store.global.state.cookieConsent)

    return { store, user, routeStore, theme, userStore, cookieModal, feedbackModal, routeLimitExceeded }
  }
})
</script>

<style lang="scss">
@import 'styles/main.scss';

#content {
  min-height: calc(100vh - var(--height-header) - var(--height-footer));
}
#app.Route header {
  display: none;
}
#app.Route #content {
  min-height: unset;
}

#feedback {
  position: fixed;
  bottom: calc(1rem + var(--margin-bottom));
  right: 1rem;
  z-index: 100000;
}

@media only screen and (max-width: $width-mobile) {
  #app.Route #feedback {
    display: none;
  }
  #app:not(.nav-open) #page {
    border-radius: 0;
  }
  #app.nav-open #page {
    transform: translateX(20rem);
  }
  #page {
    left: 0;
  }
}

</style>
